import React from "react";
import styled from "styled-components";
import Input from "../common/Input";
import {useFolderStore} from "../../app/store/FolderStore";
import {folderFileNameNotAllow} from "../../app/util";
import {toast} from "react-toastify";

const FolderAddView = ({
                           entryType,
                           depth,
                           modalDepth,
                           mutateFoldersAndBookmarks,
                       }) => {
    const folderStore = useFolderStore();

    const addFolderAction = async (ev) => {
        if (ev.nativeEvent.isComposing) return;
        if (folderFileNameNotAllow(ev.target.value)) {
            toast("사용 불가능한 문자가 포함 되어있습니다.");
            return;
        }
        try {
            await folderStore.addNewFolderFunc(ev.target.value, entryType, modalDepth)
            await mutateFoldersAndBookmarks();
            ev.target.value = ""; // input 폴더명 비우기
            toast(`신규 폴더가 생성 되었습니다.`);
        } catch (e) {
            console.log(e);
        } finally {
            folderStore.setAddFolder('TREE', false); // 인풋 닫기
        }
    }

    return (
        <EntryContainer className={"add-folder-container"}>
            <NavContents
                className={
                    (depth === 1 ? "" : "" ||
                    depth === 2 ? "tab-second" : "" ||
                    depth === 3 ? "tab-third" : "" ||
                    depth === 4 ? "tab-fourth" : "")
                }
            >

                <Input
                    inputType={"text"}
                    placeholder={"새 폴더"}
                    autoFocus={true}
                    onBlur={async (ev) => {
                        if (ev.target.value.trim() === "") {
                            return folderStore.setAddFolder('ETC', false);
                        }
                        await addFolderAction(ev);
                    }}
                    onKeyDown={async (ev) => {
                        // eslint-disable-next-line default-case
                        switch (ev.key) {
                            case 'Escape':
                                folderStore.setAddFolder('TREE', false);
                                break;
                            case 'Enter':
                                await addFolderAction(ev)
                                break;
                            default:
                                break;
                        }
                    }}
                />
                {/*<button type={"button"} onClick={() => {*/}
                {/*    setAddFolder(false);*/}
                {/*}}>*/}
                {/*    <img src={IcClose} alt={"새 폴더 생성 취소"}/>*/}
                {/*</button>*/}

            </NavContents>
        </EntryContainer>
    );
};
export default FolderAddView;

export const ItemButton = styled.div`
    cursor: pointer;
    width: 100%;
    position: relative;
    background: #f8f7f3;
`;
export const ItemPlusMinus = styled.button`
`;
export const EntryContainer = styled.div`
`;

export const NavContents = styled.div`
    width: calc(100% - 32px);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 6px;
    margin: 8px 16px;
    cursor: pointer;

    > div {
        width: 100%;
    }

    .wrap {
        display: flex;
        align-items: center;
        cursor: pointer;
        color: var(--Gray-1000_-262626, #262626);
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: -0.13px;

        img {
            margin-right: 5px;
        }
    }

    &.tab-second {
        padding-left: 32px;
    }

    &.tab-third {
        padding-left: 48px;
    }

    &.tab-fourth {
        padding-left: 82px;
    }

    &.active {
        .folder-arrow-icon {
            transform: rotate(90deg);
        }

        .wrap {
            color: var(--primary-500-c-86733, #c86733);
            font-weight: 500;
        }
    }

    & .icStar {
        margin-left: auto;
    }
`;
